import i18n from '../../managers/i18n'

i18n.register(
  'zh-Hans',
  {
    prev: '上一条',
    next: '下一条',
    indicator: '第 {index} 条，共 {total} 条',
    close: '关闭'
  },
  {
    ns: 'alert'
  }
)
